export const AssignFormToClientDefaultValue = (school, form) => {
  return {
    school_id: school?.[0]?.id,
    form_id: form?.[0]?.id,
  };
};

export default AssignFormToClientDefaultValue;
